import { useEffect } from "react";
import { motion } from "framer-motion";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { Marquee } from "@/components/Marquee";
import { Gallery } from "@/components/Gallery";
import { HowItWorks } from "@/components/HowItWorks";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "BeaconShield — Find care faster";
  }, []);

  return (
    <motion.main data-testid="landing-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }}>
      <Nav landing />
      <Hero />
      <TrustStrip />
      <Marquee />
      <Gallery />
      <HowItWorks />
      <Footer />
    </motion.main>
  );
}
